export default __webpack_public_path__ + "assets/space_strategy.5cdc7d8b.png";